// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/chunk-" + chunkId + "." + {"658":"f0ee471c051c81fc1f4a","854":"049342b8150b0ef0257d"}[chunkId] + ".js";
};